import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import { Link } from "react-router-dom";
import { userSignup, userSignin } from "../../redux/api/auth/authApi";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import { requestNotificationPermission } from "../../Notification/Messaging";
const Signin = () => {
  const [isRightPanelActive, setIsRightPanelActive] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordd, setShowPasswordd] = useState(false);
  const mobileRef = useRef(null);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const [ismobile, setIsmobile] = useState(false);
  const desktopRef = useRef(null);
  // function to check screen size and show hide contente
  const handleResize = () => {
    if (window.innerWidth < 600) {
      desktopRef.current.classList.add("d-none");
      mobileRef.current.classList.remove("d-none");
      setIsmobile(true);
    } else {
      desktopRef.current.classList.remove("d-none");
      mobileRef.current.classList.add("d-none");
      setIsmobile(false);
    }
  };
  useEffect(() => {
    handleResize(); // Check the screen width on the first load
    window.addEventListener("resize", handleResize); // Listen for screen size changes

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleShowHide = () => {
    setShowPassword(!showPassword);
  };
  const handleShowHidee = () => {
    setShowPasswordd(!showPasswordd);
  };
  const handleSignin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      password: password,
      email: email,
    };
    try {
      const response = await userSignin(data);
      if (response.success) {
        toast.success("Login Successful!");
        console.log({ response });
        const res = await requestNotificationPermission(response?.userRes[0]?.email);
        // console.log("this is notificaton" ,res)
        localStorage.setItem("authToken", response.authToken);
        const name = localStorage.setItem("name", response?.userRes[0]?.employeeName);
        console.log("name", name);
        localStorage.setItem("email", response?.userRes[0]?.email);
        localStorage.setItem("userId", response?.userRes[0]?.ROWID);
        localStorage.setItem("permissions", response?.userRes[0]?.permissions);
        localStorage.setItem("departmentName", response?.userRes[0]?.department);
        navigate("/home");
      } else {
        toast.error("Invalid email or password!");
        console.log(response.msg || "Login failed. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again");
      console.log("An error occurred. Please try again.");
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignup = async (e) => {
    e.preventDefault();
    // setIsLoading(true);
    const data = {
      firstName: name,
      email: email,
      password: password,
    };
    try {
      const response = await userSignup(data);
      setIsLoading(true);
      if (response.message === "User created successfully!") {
        sessionStorage.setItem("tempEmail", email);
        setIsLoading(false);
        toast.success("User Signup Successful.");
        // navigate("/dashboard");
        navigate("/otp-page");
      } else if (response.message === "Verified your email Account" || response.message === "Email already exists") {
        sessionStorage.setItem("tempEmail", email);
        toast.info("Account already exists. Please verify your email.");
        navigate("/");
      } else {
        setIsLoading(false);
        toast.error(response.message || "user Signup failed. Please try again.");
        // console.log(response.message || "user Signup failed. Please try again.");
      }
    } catch (error) {
      setIsLoading(false);

      toast.error(error.message || "User signup failed. Please try again.");
      console.log("An error occurred. Please try again.");
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      <div ref={desktopRef} style={{ maxHeight: ismobile ? "98vh" : "80vh" }}>
        <div className="outer">
          <div className={`containerr ${isRightPanelActive ? "right-panel-active" : ""}`}>
            {/* Sign In Container */}
            <div className={`Login-container sign-in-container ${isRightPanelActive ? "inactive" : "active"}`}>
              <form className="formClass" onSubmit={handleSignin}>
                <h1 className="mb-4">Sign in</h1>
                <input
                  type="text"
                  placeholder="Username"
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                {/* <input type="password" placeholder="Password" required   onChange={(e) => { setPassword(e.target.value); }}/> */}
                <div className="d-flex rounded-3 text-center" style={{ background: "#EEEEEE", width: "99%", height: "50px" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    placeholder="Password"
                    required
                    style={{ background: "#EEEEEE" }}
                    className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                  />
                  <span onClick={handleShowHide} className="d-flex mx-2 " style={{ alignItems: "center", cursor: "pointer" }}>
                    {showPassword ? <Eye className="cursor-pointer" /> : <EyeOff className="cursor-pointer" />}
                  </span>
                </div>

                <Link to="/forgot-password">
                  <span style={{ cursor: "pointer", color: "blue" }}>Forgot Password</span>
                </Link>
                {/* <PinInput /> */}
                <button type="submit" className="create-button mt-5">
                  Sign In
                </button>
              </form>
            </div>

            {/* Sign Up Container */}
            <div className={`Login-container sign-up-container ${isRightPanelActive ? "active" : "inactive"}`}>
              <form className="formClass" onSubmit={handleSignup}>
                <h1 className="py-3">Create Account</h1>
                <input type="text" placeholder="Name" name="name" onChange={(e) => setName(e.target.value)} required />
                <input type="email" placeholder="Email" name="email" onChange={(e) => setEmail(e.target.value)} required />
                {/* <input type="password" placeholder="Password" name="password" onChange={(e) => setPassword(e.target.value)} required /> */}

                <div className="d-flex rounded-3 text-center" style={{ background: "#EEEEEE", width: "99%", height: "50px" }}>
                  <input
                    type={showPasswordd ? "text" : "password"}
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                    style={{ background: "#EEEEEE" }}
                    className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                  />
                  <span onClick={handleShowHidee} className="d-flex mx-2 " style={{ alignItems: "center", cursor: "pointer" }}>
                    {showPasswordd ? <Eye className="cursor-pointer" /> : <EyeOff className="cursor-pointer" />}
                  </span>
                </div>

                <button type="submit" className="create-button mt-4" onClick={handleSignup}>
                  Sign Up
                </button>
              </form>
            </div>

            {/* Overlay for Switching Forms */}
            <div className="overlay-container">
              <div className="overlay">
                <div className="overlay-panel overlay-left">
                  <h1>Welcome Back!</h1>
                  <p className="singinP">To keep connected with us please login with your personal info</p>
                  <button className="create-button" onClick={() => setIsRightPanelActive(false)}>
                    Sign In
                  </button>
                </div>
                <div className="overlay-panel overlay-right">
                  {/* <h1></h1> */}
                  {/* <img src="https://i.ibb.co/pj8jyqYc/solar-logo.webp" /> */}
                  <img
                    src="https://i.ibb.co/zhS5XSJB/Numbardar-Solar-removebg-preview.png"
                    alt="Numbardar-Solar-preview"
                    border="0"
                    style={{
                      background: "white",
                      height: "30%",
                      width: "50%",
                      borderRadius: "30px",
                    }}
                  />
                  <p className="singinP">Enter your personal details and start your journey with us</p>
                  <buttons className="create-button" onClick={() => setIsRightPanelActive(true)}>
                    Sign Up
                  </buttons>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={mobileRef} style={{ maxHeight: "100vh", backgroundColor: "white" }} className="d-none">
        <div className={`Login-container sign-in-container`} style={{ height: "100vh", marginTop: "0px" }}>
          <form className="formClass" onSubmit={handleSignin}>
            <img
              src="https://i.ibb.co/zhS5XSJB/Numbardar-Solar-removebg-preview.png"
              alt="Numbardar-Solar-preview"
              border="0"
              style={{
                background: "white",
                height: "20%",
                width: "50%",
                borderRadius: "30px",
              }}
            />
            <h1 className="my-4" style={{ fontWeight: "700", fontSize: "34px" }}>
              Sign in
            </h1>

            <div className="d-flex rounded-3 text-center" style={{ background: "#EEEEEE", width: "100%", height: "50px" }}>
              <input
                type="text"
                placeholder="Username"
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
                style={{ background: "#EEEEEE" }}
              />
            </div>
            {/* <input type="password" placeholder="Password" required   onChange={(e) => { setPassword(e.target.value); }}/> */}
            <div className="d-flex rounded-3 text-center mt-3" style={{ background: "#EEEEEE", width: "99%", height: "50px" }}>
              <input
                type={showPassword ? "text" : "password"}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                placeholder="Password"
                required
                style={{ background: "#EEEEEE" }}
                className="form-control border-0 shadow-none px-3 py-2 text-gray-600"
              />
              <span onClick={handleShowHide} className="d-flex mx-2 " style={{ alignItems: "center", cursor: "pointer" }}>
                {showPassword ? <Eye className="cursor-pointer" /> : <EyeOff className="cursor-pointer" />}
              </span>
            </div>

            <Link to="/forgot-password">
              <span style={{ cursor: "pointer", color: "blue" }}>Forgot Password</span>
            </Link>
            {/* <PinInput /> */}
            <button type="submit" className="create-button mt-5 w-100">
              Sign In
            </button>
            {/* <button type="button" className="create-button mt-3" style={{ width: '100%' }} onClick={() => { setIsSignupOpen(false) }}>
              Sign Up
            </button> */}
          </form>
        </div>
      </div>
    </>
  );
};

export default Signin;
